// Copyright 1999-2024. WebPros International GmbH. All rights reserved.

import { api } from 'common/api/resources/Response';
import { ITaskResponse } from 'common/api/resources/Task';

export const snapshots = {
    remove: (id: number) => api.delete(`snapshots/${id}`),
    revert: (id: number) => api.post<ITaskResponse>(`snapshots/${id}/revert`),
};
